import React, { useState } from 'react';
import { FiCheckSquare, FiSquare, FiChevronDown, FiChevronRight } from 'react-icons/fi';
import { useSubscriptions } from '../contexts/SubscriptionContext';

const SubscriptionSettings = () => {
  const { subscriptions, toggleCitySubscription, toggleCityCategorySubscription } = useSubscriptions();
  const [expandedCities, setExpandedCities] = useState({});

  // Toggle city expansion
  const toggleCityExpansion = (city) => {
    setExpandedCities({
      ...expandedCities,
      [city]: !expandedCities[city]
    });
  };

  // Handle city subscription toggle
  const handleCitySubscription = (city) => {
    toggleCitySubscription(city);
  };

  // Handle category subscription toggle
  const handleCategorySubscription = (city, category) => {
    toggleCityCategorySubscription(city, category);
  };

  return (
    <div className="subscription-settings">
      <h2 className="settings-title">Notification Settings</h2>
      
      {/* City Subscriptions */}
      <div className="settings-section">
        <h3 className="section-title">City Notifications</h3>
        <p className="section-description">
          Choose which cities and notification types you want to receive
        </p>
        {Object.entries(subscriptions.cities).map(([cityName, cityData]) => (
          <div key={cityName} className="subscription-item">
            <div className="subscription-header" onClick={() => toggleCityExpansion(cityName)}>
              <div className="subscription-info">
                <div 
                  className="subscription-checkbox"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCitySubscription(cityName);
                  }}
                >
                  {cityData.subscribed ? (
                    <FiCheckSquare className="checkbox-icon checked" />
                  ) : (
                    <FiSquare className="checkbox-icon" />
                  )}
                </div>
                <span className="subscription-name">{cityName}</span>
              </div>
              <div className="subscription-arrow">
                {expandedCities[cityName] ? <FiChevronDown /> : <FiChevronRight />}
              </div>
            </div>
            
            {expandedCities[cityName] && (
              <div className="subscription-categories">
                {Object.entries(cityData.categories).map(([category, isSubscribed]) => (
                  <div 
                    key={category} 
                    className="category-item"
                    onClick={() => handleCategorySubscription(cityName, category)}
                  >
                    {isSubscribed ? (
                      <FiCheckSquare className="checkbox-icon checked" />
                    ) : (
                      <FiSquare className="checkbox-icon" />
                    )}
                    <span className="category-name">{category}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Information about business notifications */}
      <div className="settings-section">
        <h3 className="section-title">Business Notifications</h3>
        <p className="section-description">
          Business notifications are automatically delivered and cannot be disabled. 
          These include important updates from healthcare providers, retailers, and utilities.
        </p>
      </div>
    </div>
  );
};

export default SubscriptionSettings;